import * as meditationIcon from 'src/public/img/meditation-image-page.png';

import { ProgramEnum, ProgramWeekEnum } from '../../models/programs';
import {
    initialFlexibilityExerciseData,
    initialFlexibilityPlan,
    initialFlexibilityPracticeData,
    weekFourData,
} from '../weekFour/models/weekFourData';
import { initialMindfulnessImprovementsData, weekOneData } from '../weekOne/models/weekOneData';
import {
    cpProgramSharedStepsProps,
    initialCorePillarsRatingData,
} from '../weekShared/models/weekSharedData';
import { initialActivitiesDomains, weekThreeData } from '../weekThree/models/weekThreeData';
import { initialValuesAssessmentsData, weekTwoData } from '../weekTwo/models/weekTwoData';
import { CPProgramState, CPProgramWeek } from './cpProgram';

export const cpProgramWeeksData: CPProgramWeek[] = [
    weekOneData,
    weekTwoData,
    weekThreeData,
    weekFourData,
];

export const initialFeedbackData = Object.values(ProgramWeekEnum).map(weekId => ({
    weekId,
    rating: 0,
    content: '',
}));

export const cpProgramDefaultState: CPProgramState = {
    id: ProgramEnum.CP,
    title: 'Core Pillars',
    iconUrl: meditationIcon,
    weeks: cpProgramWeeksData,
    sharedStepsProps: cpProgramSharedStepsProps,
    corePillarsRating: initialCorePillarsRatingData,
    isMindfulnessExerciseCompleted: false,
    mindfulnessImprovementsTopics: initialMindfulnessImprovementsData,
    homeworkConfidenceRating: 0,
    livingAccordingToValues: {
        livingWithValuesFeelings: '',
        livingAgainstValuesFeelings: '',
    },
    valuesAssessments: initialValuesAssessmentsData,
    activitiesSelection: initialActivitiesDomains,
    flexibilityPracticeQuestion: initialFlexibilityPracticeData,
    flexibilityExerciseQuestions: initialFlexibilityExerciseData,
    flexibilityPlan: initialFlexibilityPlan,
};
